import { BaseProperties, SPBox, SPLoading } from '@group-link-one/gl-ui/sonarprint';
import { Suspense } from 'react';

import { VerifyRoute } from './VerifyRoute';
import { Instability } from '@/Pages/Instability/Instability';

interface CreateProtectedRouteProps {
  page: React.LazyExoticComponent<React.ComponentType>;
  needAuth: boolean;
  hasPrivileges: boolean;
  allowBoth?: boolean;
  instability?: boolean;
}

/**
 * Cria elemento de rota protegida com lazy loading
 */
export const createProtectedRoute = ({
  page: Page,
  needAuth,
  hasPrivileges,
  allowBoth = false,
  instability = false,
}: CreateProtectedRouteProps) => (
  <VerifyRoute
    needAuth={needAuth}
    userHasPrivileges={hasPrivileges}
    allowBoth={allowBoth}
    element={
      <Suspense
        fallback={
          <SPLoading screen='as-page' type='dots' style={{ backgroundColor: 'transparent' }} />
        }
      >
        {instability ? (
          <SPBox borderRadius={BaseProperties.RADIUS.ML} overflow='hidden' flex={1}>
            <Instability customHeight='100%' />
          </SPBox>
        ) : (
          <Page />
        )}
      </Suspense>
    }
  />
);
